import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { SEARCH_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useSearchCarsSocket'
import { useUpdateCar } from '@autobid/ui/composables/car/useUpdateCar'

export function useSearchCarSold() {
  const { startListen } = useWebSocketStore()
  const { updateSearchCar } = useUpdateCar()

  const carSold = () => {
    startListen({
      eventName: 'premium.CAR_SOLD',
      callbackName: SEARCH_SOCKET_CALLBACK,
      callback: (event) => {
        const { carId } = event.context

        updateSearchCar(carId, (data) => {
          return {
            ...data,
            state: 'SOLD',
          }
        })
      },
    })
  }

  return { carSold }
}
